<page-load-header *ngIf="!initialized"></page-load-header>

<header>
  <!-- Fixed navbar -->
  <nav class="navbar nowrap navbar-expand-md navbar-light bg-white">
    <a class="navbar-brand event-title text-truncate cursor-pointer">Mulit-Event Viewer</a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarCollapse">
      <!-- <ul class="navbar-nav mr-auto">
      <li class="nav-item active">
        <a class="nav-link" href="#">Home <span class="sr-only">(current)</span></a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#">Link</a>
      </li>
      <li class="nav-item">
        <a class="nav-link disabled" href="#">Disabled</a>
      </li>
    </ul> -->
      <div class="form-inline ml-auto mt-2 mt-md-0">
        <button type="button" class="btn btn-icon text-muted transition-3d-hover">
          <h3><span class="fas fa-compress-wide btn-icon__inner"></span></h3>
        </button>

        <button type="button" class="btn btn-icon" (click)="exitPage()">
          <h3 class="m-0 text-muted"><i class="fas fa-times"></i></h3>
        </button>
      </div>
    </div>
  </nav>
</header>
<main id="live-event" class="main-container">
  <div class="main-theater">
    <div class="row no-gutters">
      <div *ngFor="let evt of events; let evtIdx = index" class="col video-container mr-1">
        <div style="height: 50px; overflow: hidden">
          <select class="form-control" [(ngModel)]="selectedEvents[evtIdx]" (ngModelChange)="eventChanged(evtIdx, evt)">
            <option [value]="event.id" *ngFor="let event of todaysEvents; let idx = index">{{ event.startTime | date: 'shortTime' }} [{{ event.roomRoomName }}] {{ event.title }}</option>
          </select>
        </div>

        <bxl-multi-view-video [connection]="connection" [event]="evt"></bxl-multi-view-video>

        <div class="chat-sidebar">
          <live-event-chat [hideCarat]="true" style="background-color: #333" #child [event]="evt" [connection]="connection"></live-event-chat>
        </div>
      </div>
    </div>
  </div>
</main>
